import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../constants/constants';

@Injectable()
export class MultilingualDateAdapter extends NativeDateAdapter {

  constructor(private translateService: TranslateService) {
    super('en-US');
  }

  override format(date: Date, displayFormat: object): string {
    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || Constants.LANGUAGE_EN_US;

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const dd = this.padNumber(day);
    const mm = this.padNumber(month);

    if (currentLang === Constants.LANGUAGE_FR_CA || currentLang === Constants.LANGUAGE_EN_CA) {
      return `${year}-${mm}-${dd}`;
    } else {
      return `${mm}/${dd}/${year}`;
    }
  }

  override parse(value: string): Date | null {
    if (!value || value.trim() === '') {
      return null;
    }

    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || Constants.LANGUAGE_EN_US;

    if (currentLang === Constants.LANGUAGE_FR_CA || currentLang === Constants.LANGUAGE_EN_CA) {
      const parts = value.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
          return new Date(year, month, day);
        }
      }
    } else {
      const parts = value.split('/');
      if (parts.length === 3) {
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
          return new Date(year, month, day);
        }
      }
    }

    return super.parse(value);
  }

  private padNumber(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
}
